<template>
	<div class="spinner-border text-primary" :class="{
		'spinner-border-sm': small,
		'spinner-border-xs': xsmall,
	}" role="status">
		<span class="sr-only">Chargement ...</span>
	</div>
</template>

<script>

	export default {
		props: {
			small: Boolean,
			xsmall: Boolean
		}
	}

</script>w